import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { JumpboxService } from 'src/app/services/api/jumpbox.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { TenantJumpboxPopupComponent } from './tenant-jumpbox-popup/tenant-jumpbox-popup.component';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { translate } from '@jsverse/transloco';
import { Permissions, Datazone, Attributes } from 'src/app/models/principal/permission';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { Jumpbox } from 'src/app/models/tenant/jumpbox';
import { ColumnFilterComponent } from '../instances-mgmt/column-filter/column-filter.component';
import { DatePipe } from '@angular/common'
import moment from 'moment';
import { StatusCodes } from 'http-status-codes';
import { FeatureKeys } from 'src/app/models/feature/feature-keys';
import { Feature, FeatureAttributes, FeatureDatazone } from 'src/app/models/feature/feature';
import { FeaturePermissionsService } from 'src/app/services/util/feature-permissions.service';
import { TenantService } from 'src/app/services/api/tenant.service';
import { CloudProvider } from 'src/app/models/cloud-provider/cloud-provider';


const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.JUMPBOX_READ_PII,
    action: Permissions.JUMPBOX_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.JUMPBOX_READ_LIVE,
    action: Permissions.JUMPBOX_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.JUMPBOX_CREATE_PII,
    action: Permissions.JUMPBOX_CREATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.JUMPBOX_CREATE_LIVE,
    action: Permissions.JUMPBOX_CREATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.JUMPBOX_UPDATE_PII,
    action: Permissions.JUMPBOX_UPDATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.JUMPBOX_UPDATE_LIVE,
    action: Permissions.JUMPBOX_UPDATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.JUMPBOX_DELETE_PII,
    action: Permissions.JUMPBOX_DELETE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.JUMPBOX_DELETE_LIVE,
    action: Permissions.JUMPBOX_DELETE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  }

];

const REQUIRED_FEATURES = [
  {
    key: FeatureKeys.JUMPBOX_PII,
    name: Feature.JUMPBOX,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.PII
  },
  {
    key: FeatureKeys.JUMPBOX_LIVE,
    name: Feature.JUMPBOX,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.LIVE
  }
];

@Component({
    selector: 'app-tenant-jumpbox',
    templateUrl: './tenant-jumpbox.component.html',
    styleUrls: ['./tenant-jumpbox.component.scss'],
    standalone: false
})
export class TenantJumpboxComponent  implements OnInit {
  tenantId: any;
  jumpboxes = [];
  showJumboxMenu: boolean;
private destroyRef = inject(DestroyRef);

  displayColumns = [
    {
      key: 'name',
      name: translate('JUMPBOX.NAME'),
      type: 'text',
      sortable: true,
      tag: true,
      tagKey: 'dataZone',
      keyLink: 'resourceUrl',
      visible: true,
      disable: true
    },
    {
      key: 'jumpboxVm',
      name: translate('JUMPBOX.VM'),
      type: 'computerIcon',
      sortable: false,
      visible: true,
      disable: false
    },
    {
      key: 'createdAt',
      name: translate('JUMPBOX.CREATED_DATE'),
      type: 'date',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'createdBy',
      name: translate('JUMPBOX.CREATED_BY'),
      type: 'userIcon',
      sortable: false,
      visible: true,
      disable: false
    },
    {
      key: 'modifiedAt',
      name: translate('JUMPBOX.MODIFIED_DATE'),
      type: 'date',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'modifiedBy',
      name: translate('JUMPBOX.MODIFIED_BY'),
      type: 'userIcon',
      sortable: false,
      visible: true,
      disable: false
    },
    {
      key: 'expiresAt',
      name: translate('JUMPBOX.EXPIRY_DATE'),
      type: 'date',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'realTime',
      name: translate('JUMPBOX.EXPIRES_ON'),
      type: 'realTime',
      sortable: true,
      visible: true,
      disable: true
    },
    {
      key: 'status',
      name: translate('JUMPBOX.STATUS'),
      type: 'status',
      sortable: true,
      visible: true,
      disable: true
    },
    {
      key: 'jumpBoxSettings',
      name: '',
      type: 'jumpBoxSettings'
    }
  ];
  jumpboxLoading = true;
  permissionsMap: { [key: string]: boolean };
  PermissionKeys = PermissionKeys;
  searchTerm: string;
  dropdownsList: any;
  status: any;
  zone: any;
  date: any;
  clearData: boolean;
  selectedStatus = [];
  selectedDatazone = [];
  jumpboxData = [];
  filteredColumns: any;
  filterStartDate: any;
  filterEndDate: any;
  filterModifiedStartDate: any;
  filterModifiedEndDate: any;
  jumpboxStatus: any;
  seelctedDate: any;
  showLoader = false;
  statusData: any;
  datazoneData: any;
  dateData: any;
  searchedResult = [];
  apiNotFound = false;
  jumpboxResponse = true;
  isFilterResultEmpty = false;
  FeatureKeys = FeatureKeys;
  featuresMap: { [key: string]: boolean };
  isAWS: boolean;

  constructor(private activatedRoute: ActivatedRoute, private router: Router,
    public jumpboxService: JumpboxService, public sidenavService: SidenavService, private featurePermissionsService: FeaturePermissionsService,
    private toastrService: CustomToastrService, private permissionsService: PermissionsService, public datePipe: DatePipe, public tenantService: TenantService) {
    
  }

  ngOnInit(): void {
    this.tenantService.tenantData$.subscribe((data: any) => {
      this.isAWS = data === CloudProvider.AWS ? true : false;
  
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    this.featuresMap = this.featurePermissionsService.resolveFeaturePermissions(REQUIRED_FEATURES);
    this.showJumboxMenu =  (this.permissionsMap[PermissionKeys.JUMPBOX_UPDATE_LIVE] || this.permissionsMap[PermissionKeys.JUMPBOX_DELETE_LIVE] || this.permissionsMap[PermissionKeys.JUMPBOX_CREATE_LIVE] || this.permissionsMap[PermissionKeys.JUMPBOX_READ_LIVE] ||
                           this.permissionsMap[PermissionKeys.JUMPBOX_UPDATE_PII] || this.permissionsMap[PermissionKeys.JUMPBOX_DELETE_PII] || this.permissionsMap[PermissionKeys.JUMPBOX_CREATE_PII] || this.permissionsMap[PermissionKeys.JUMPBOX_READ_PII]);
    this.jumpboxLoading = false;
    });
    this.sidenavService.tenantSelectedMenu = 'TENANT_LAYOUT.MENU.JUMPBOX';
    this.tenantId = this.activatedRoute.snapshot.params.id;
    this.getJumpboxes();

    this.jumpboxStatus = [
      {value: 'inprogress', label: "In Progress",selected: false},
      {value: 'completed', label: "Completed", selected: false},
      {value: 'failed', label: "Failed", selected: false},
      {value: 'deleting', label: "Deleting", selected: false},
      {value: 'deleted', label: "Deleted", selected: false},
      {value: 'deletion_failed', label: "Delete Failed", selected: false}
    ];

    const zone = [
      {value: 'pii', selected: false},
      {value: 'prod', selected: false},
    ];

    const date = [
      {value: 'Created date', selected: false},
      {value: 'Modified date', selected: false},
    ];

    this.dropdownsList = [
      {
        title: 'Status',
        placeholder: 'Select Status',
        options: this.jumpboxStatus
      },
      {
        title: 'Zone',
        placeholder: 'Select Zone',
        options: zone
      },
      {
        title: 'Date',
        placeholder: 'Select Zone',
        options: date
      }
    ];

    if (localStorage.getItem('filteredJumpboxStatus')) {
      this.statusData = JSON.parse(localStorage.getItem('filteredJumpboxStatus'));
      if (this.statusData) {
        this.selectedStatus = this.statusData;
        this.status = this.selectedStatus;
        this.dropdownsList[0].options.forEach(element => {
          if(this.selectedStatus.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }

    if (localStorage.getItem('filteredJumpboxDatazone')) {
      this.datazoneData = JSON.parse(localStorage.getItem('filteredJumpboxDatazone'));
      if (this.datazoneData) {
        this.selectedDatazone = this.datazoneData;
        this.zone = this.selectedDatazone;
        this.dropdownsList[1].options.forEach(element => {
          if(this.selectedDatazone.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }

    if (localStorage.getItem('filteredJumpboxDate')) {
      this.dateData = JSON.parse(localStorage.getItem('filteredJumpboxDate'));
      if (this.dateData) {
        this.date = this.dateData;
        this.dropdownsList[2].options.forEach(element => {
          if(this.dateData.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }

    this.filterStartDate = localStorage.getItem('filteredJumpboxStartDate') ? localStorage.getItem('filteredJumpboxStartDate'): '';
    this.filterEndDate = localStorage.getItem('filteredJumpboxEndDate') ? localStorage.getItem('filteredJumpboxEndDate'): '';
    this.filterModifiedStartDate = localStorage.getItem('filteredJumpboxModifiedStartDate') ? localStorage.getItem('filteredJumpboxModifiedStartDate'): '';
    this.filterModifiedEndDate = localStorage.getItem('filteredJumpboxModifiedEndDate') ? localStorage.getItem('filteredJumpboxModifiedEndDate'): '';
  }

  onCreateNewJumpbox(): void {
    const data = {
      tenantId : this.tenantId,
      jumpboxData: this.jumpboxes
    }
    this.sidenavService.openInRightSidenav(TenantJumpboxPopupComponent, data).subscribe(response => {
      if (response) {
        this.getJumpboxes();
        this.showLoader = true;
      }
    });
  }

  getJumpboxes(): void {
    this.jumpboxService.getJumpboxes(this.tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: Jumpbox[]) => {
        data = data?.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
        this.jumpboxLoading = false;
        this.showLoader = false;
        this.jumpboxes = data;
        this.jumpboxData = data;
        this.searchTerm = '';
        if (this.statusData?.length || this.datazoneData?.length || this.dateData?.length) {
          this.initialFilterItems();
        }
        this.jumpboxData.length > 0 ? this.jumpboxResponse=true: this.jumpboxResponse = false;
      },
      (error) => {
        if((this.permissionsMap[PermissionKeys.JUMPBOX_CREATE_LIVE]) || ( this.permissionsMap[PermissionKeys.JUMPBOX_CREATE_PII])){
        if (error.httpStatusCode === 404){
          this.apiNotFound = true;
        }else{
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
        }
      }
      });
  }

   search(searchTerm?: string): void {
      this.searchTerm = searchTerm;
    }

    searchedItems(result): void {
      this.searchedResult = result;
    }
    
    filterColumns(): void {
        if(this.status) {
          this.dropdownsList[0].options.filter((item) => {
            if (this.status?.find(status => status === item.value)) {
              item.selected = true;
            } else {
              item.selected = false;
            }
          });
        } else {
          this.dropdownsList[0].options.filter((item) => {
            item.selected = false;
          });
        }
        if(this.zone) {
          this.dropdownsList[1].options.filter((item) => {
            if (this.zone?.find(zone => zone === item.value)) {
              item.selected = true;
            } else {
              item.selected = false;
            }
          });
        } else {
          this.dropdownsList[1].options.filter((item) => {
            item.selected = false;
          });
        }
        if(this.date) {
          this.dropdownsList[2].options.filter((item) => {
            if (this.date?.find(date => date === item.value)) {
              item.selected = true;
            } else {
              item.selected = false;
            }
          });
        } else {
          this.dropdownsList[2].options.filter((item) => {
            item.selected = false;
          });
        }
        const data = {
          name: translate('JUMPBOX.JUMPBOX_FILTER_NAME'),
          title: translate('INSTANCE_STATUS.FILTER_TITLE'),
          subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
          filteredColumns: this.dropdownsList,
          JBStatus: this.dropdownsList[0].options,
          JBZone: this.dropdownsList[1].options,
          JBDate: this.dropdownsList[2].options,
          startDate: this.dropdownsList[2].options[0]?.selected ? moment(this.filterStartDate) : '',
          endDate: this.dropdownsList[2].options[0]?.selected ? moment(this.filterEndDate) : '',
          filterModifiedStartDate: this.dropdownsList[2].options[1]?.selected ? moment(this.filterModifiedStartDate): '',
          filterModifiedEndDate: this.dropdownsList[2].options[1]?.selected ? moment(this.filterModifiedEndDate): '',
          jumpboxColumns: [
            'status',
            'zone',
            'date'
          ]
        };
        this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(filteredColumns => {
          this.filteredColumns = filteredColumns;
          if (filteredColumns) {
            this.clearData = true;
            if(filteredColumns[0] !== '') {
              this.status = filteredColumns[0];
            }
            if(filteredColumns[1] !== '') {
              this.zone = filteredColumns[1];
            }
            if(filteredColumns[2] !== '') {
              localStorage.removeItem('filteredJumpboxDate');
              this.date = filteredColumns[2];
              localStorage.setItem('filteredJumpboxDate', JSON.stringify(filteredColumns[2]));
            }

            if (filteredColumns[0]?.length === 0 && filteredColumns[1]?.length === 0 && filteredColumns[2]?.length === 0){
              this.resetJumpboxFilter();
            } else {
              this.filterJumpboxItems(filteredColumns);
            }
          }
        });
      }

      cancelStatusFilter(data) {
        let selectedItem = this.selectedStatus.indexOf(data);
        if (selectedItem > -1) {
          localStorage.removeItem('filteredJumpboxStatus');
          this.selectedStatus.splice(selectedItem, 1);
          this.dropdownsList[0].options.find(item => item.value === data).selected = false;
          localStorage.setItem('filteredJumpboxStatus', JSON.stringify(this.selectedStatus));
          this.filterJumpboxItems(this.filteredColumns);
        }
        if (this.selectedStatus.length === 0 && this.selectedDatazone.length === 0) {
          this.jumpboxes = this.jumpboxData;
        }
      }

      cancelDatazoneFilter(data) {
        let selectedItem = this.selectedDatazone.indexOf(data);
        if (selectedItem > -1) {
          localStorage.removeItem('filteredJumpboxDatazone');
          this.selectedDatazone.splice(selectedItem, 1);
          this.dropdownsList[1].options.find(item => item.value === data).selected = false;
          localStorage.setItem('filteredJumpboxDatazone', JSON.stringify(this.selectedDatazone));
          this.filterJumpboxItems(this.filteredColumns);
        }
        if (this.selectedStatus.length === 0 && this.selectedDatazone.length === 0) {
          this.jumpboxes = this.jumpboxData;
        }
      }

      cancelCreatedDateFilter() {
        this.filterStartDate = undefined;
        this.filterEndDate = undefined;
        this.dropdownsList[2].options[0].selected = false;
        this.date?.forEach(element => {
          if(element.includes(this.dropdownsList[2].options[0].value)) {
            this.date.pop(element);
          }
        });

        localStorage.removeItem('filteredJumpboxStartDate');
        localStorage.removeItem('filteredJumpboxEndDate');
        localStorage.removeItem('filteredJumpboxDate');
        if (this.dropdownsList[2].options[1].selected) {
          localStorage.setItem('filteredJumpboxDate', JSON.stringify([this.dropdownsList[2].options[1].value]));
        }
        this.filterJumpboxItems(this.filteredColumns);
      }

      cancelModifiedDateFilter() {
        this.filterModifiedStartDate = false;
        this.filterModifiedEndDate = false;
        this.dropdownsList[2].options[1].selected = false;
        this.date?.forEach(element => {
          if(element.includes(this.dropdownsList[2].options[1].value)) {
            this.date.pop(element);
          }
        });

        localStorage.removeItem('filteredJumpboxModifiedStartDate');
        localStorage.removeItem('filteredJumpboxModifiedEndDate');
        localStorage.removeItem('filteredJumpboxDate');
        if (this.dropdownsList[2].options[0].selected) {
          localStorage.setItem('filteredJumpboxDate', JSON.stringify([this.dropdownsList[2].options[0].value]));
        }
        this.filterJumpboxItems(this.filteredColumns);
      }

      filterJumpboxItems(filteredColumns): void {
        if (filteredColumns) {
          this.jumpboxes = this.jumpboxData;
          this.selectedStatus = [];
          this.selectedDatazone = [];

          if (filteredColumns[0]?.length > 0) {
            this.selectedStatus = filteredColumns[0];
            if (filteredColumns[0].length > 0) {
              localStorage.setItem('filteredJumpboxStatus', JSON.stringify(this.selectedStatus));
              this.jumpboxes = this.jumpboxes?.filter(item => this.selectedStatus?.includes(item?.status));
            } else {
              localStorage.removeItem('filteredJumpboxStatus');
            }
          }

          if (filteredColumns[1]?.length > 0) {
            this.selectedDatazone = filteredColumns[1];
            if (filteredColumns[1].length > 0) {
              localStorage.setItem('filteredJumpboxDatazone', JSON.stringify(this.selectedDatazone));
              this.jumpboxes = this.jumpboxes?.filter(item => this.selectedDatazone?.includes(item?.dataZone));
            } else {
              localStorage.removeItem('filteredJumpboxDatazone');
            }
          }

          if (this.dropdownsList[2].options[0].selected && moment(filteredColumns[3].filteredStartDate).isValid() && moment(filteredColumns[3].filteredEndDate).isValid()) {
            this.filterStartDate = filteredColumns[3].filteredStartDate;
            this.filterEndDate = filteredColumns[3].filteredEndDate;
            localStorage.setItem('filteredJumpboxStartDate', this.filterStartDate);
            localStorage.setItem('filteredJumpboxEndDate', this.filterEndDate);
            this.jumpboxes = this.jumpboxes?.filter(item => this.datePipe.transform(item.createdAt, 'yyyy-MM-dd') >= this.datePipe.transform(this.filterStartDate, 'yyyy-MM-dd') &&
              this.datePipe.transform(item.createdAt, 'yyyy-MM-dd') <= this.datePipe.transform(this.filterEndDate, 'yyyy-MM-dd'));
          } else {
            this.filterStartDate = undefined;
            this.filterEndDate = undefined;
            localStorage.removeItem('filteredJumpboxStartDate');
            localStorage.removeItem('filteredJumpboxEndDate');
          }

          if (this.dropdownsList[2].options[1].selected && moment(filteredColumns[5].filteredModifiedStartDate).isValid() && moment(filteredColumns[5].filteredModifiedEndDate).isValid()) {
            this.filterModifiedStartDate = filteredColumns[5].filteredModifiedStartDate;
            this.filterModifiedEndDate = filteredColumns[5].filteredModifiedEndDate;
            localStorage.setItem('filteredJumpboxModifiedStartDate', this.filterModifiedStartDate);
            localStorage.setItem('filteredJumpboxModifiedEndDate', this.filterModifiedEndDate);
            this.jumpboxes = this.jumpboxes?.filter(item => this.datePipe.transform(item.modifiedAt, 'yyyy-MM-dd') >= this.datePipe.transform(this.filterModifiedStartDate, 'yyyy-MM-dd') &&
              this.datePipe.transform(item.modifiedAt, 'yyyy-MM-dd') <= this.datePipe.transform(this.filterModifiedEndDate, 'yyyy-MM-dd'));
          } else {
            this.filterModifiedStartDate = undefined;
            this.filterModifiedEndDate = undefined;
            localStorage.removeItem('filteredJumpboxModifiedStartDate');
            localStorage.removeItem('filteredJumpboxModifiedEndDate');
          }
          if(this.jumpboxes.length == 0){
            this.isFilterResultEmpty = true;
          }else{
            this.isFilterResultEmpty = false;
          }
        }
      }

      initialFilterItems() {
        this.jumpboxes = this.jumpboxData;
        if (this.selectedStatus?.length > 0) {
          this.jumpboxes = this.jumpboxes?.filter(item => this.selectedStatus?.includes(item?.status));
        }

        if (this.selectedDatazone?.length > 0) {
          this.jumpboxes = this.jumpboxes?.filter(item => this.selectedDatazone?.includes(item?.dataZone));
        }
        if (this.dropdownsList[2].options[0].selected && this.filterStartDate && this.filterEndDate) {
          this.jumpboxes = this.jumpboxes?.filter(item => this.datePipe.transform(item.createdAt, 'yyyy-MM-dd') >= this.datePipe.transform(this.filterStartDate, 'yyyy-MM-dd') &&
            this.datePipe.transform(item.createdAt, 'yyyy-MM-dd') <= this.datePipe.transform(this.filterEndDate, 'yyyy-MM-dd'));
        }
        if (this.dropdownsList[2].options[1].selected && this.filterModifiedStartDate && this.filterModifiedEndDate) {
          this.jumpboxes = this.jumpboxes?.filter(item => this.datePipe.transform(item.modifiedAt, 'yyyy-MM-dd') >= this.datePipe.transform(this.filterModifiedStartDate, 'yyyy-MM-dd') &&
            this.datePipe.transform(item.modifiedAt, 'yyyy-MM-dd') <= this.datePipe.transform(this.filterModifiedEndDate, 'yyyy-MM-dd'));
        }
        if(this.jumpboxes.length == 0){
          this.isFilterResultEmpty = true;
        }else{
          this.isFilterResultEmpty = false;
        }
      }

      resetJumpboxFilter(): void {
        this.selectedStatus = [];
        this.selectedDatazone = [];
        this.sidenavService.searchFilter.next('data');
        this.dropdownsList[0].options.filter((item) => {item.selected = false});
        this.dropdownsList[1].options.filter((item) => {item.selected = false});
        this.dropdownsList[2].options.filter((item) => {item.selected = false});
        this.status = undefined;
        this.zone = undefined;
        this.date = undefined;
        this.filterStartDate = undefined;
        this.filterEndDate = undefined;
        this.filterModifiedStartDate = undefined;
        this.filterModifiedEndDate = undefined;
        this.jumpboxes = this.jumpboxData;
        localStorage.removeItem('filteredJumpboxStatus');
        localStorage.removeItem('filteredJumpboxDatazone');
        localStorage.removeItem('filteredJumpboxDate');
        localStorage.removeItem('filteredJumpboxStartDate');
        localStorage.removeItem('filteredJumpboxEndDate');
        localStorage.removeItem('filteredJumpboxModifiedStartDate');
        localStorage.removeItem('filteredJumpboxModifiedEndDate');
      }

      getStatusLabel(status): void {
        return this.jumpboxStatus.find(item=> item.value === status).label;
      }

  refreshClick(): void {
    this.getJumpboxes();
    this.showLoader = true;
  }
}
